export default {
    variants: {
        outline: {
            _disabled: {
                borderColor: 'stroke.light',
                color: 'text.secondary',
                _hover: {
                    borderColor: 'stroke.light'
                }
            },
            _focusVisible: {
                borderColor: 'stroke.interactive',
                boxShadow: 'none',
                textStyle: 'mBold'
            },
            _hover: {
                borderColor: 'stroke.interactive'
            },
            _invalid: {
                borderColor: 'stroke.error',
                color: 'text.error',
                boxShadow: 'none'
            },
            _placeholder: {
                color: 'text.secondary'
            },
            bg: 'fill.white',
            borderColor: 'stroke.medium',
            borderRadius: 'lg',
            color: 'text.secondary',
            px: 1.5,
            py: 1.5,
            textStyle: 'm'
        }
    },
    defaultProps: {
        variant: 'outline'
    }
};

//# sourceMappingURL=textarea.js.map